export default __webpack_public_path__ + "static/media/spain.8585d354.png";